module.exports = __webpack_public_path__ + "img/P53-en.eedd3bde.png";